import React, { PureComponent } from 'react';

import { message as AntMessage, Popconfirm as AntPopconfirm } from 'antd';
import { services } from '@comall-backend-builder/core';
import { Button } from '@comall-backend-builder/components-basis';
import { errorHandle } from '../../services';

const api = services.api;
/**
 * 商品资料导出，导出后，不需要下载，仅需要提示导出成功
 */
export class ProductInfoExportButton extends PureComponent<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    handleClick = () => {
        if (this.state.loading) {
            return;
        }

        this.setState({ loading: true });

        const { entity: { filters, paging: { page, perPage } }, source } = this.props;
        const params = {
            page,
            perPage,
            ...filters,
        };
        api.get(params, source).then(() => {
            this.setState({ loading: false });
            AntMessage.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
        }).catch(errorHandle);
    }

    render() {
        const confirmProps = {
            title: '确定要导出商品资料吗？',
            okText: '确定',
            cancelText: '取消',
            onConfirm: this.handleClick,
        };
        const btnProps = Object.assign({}, this.props, {
            loading: this.state.loading
        });
        return (
            <AntPopconfirm {...confirmProps}>
                <Button {...btnProps} />
            </AntPopconfirm>
        );
    }
}
